import { promises } from "config/algolia";

const DEFAULT_LENGTH = 10;
export const getPromises = async ({
  filters = "",
  searchText = "",
  length = DEFAULT_LENGTH,
  offset = 0,
}) => {
  const result = await promises.search(searchText, {
    filters,
    length,
    page: offset,
    hitsPerPage: length,
    highlightPreTag: "<mark>",
    highlightPostTag: "</mark>",
  });
  return {
    hits: result.hits,
    hitsLength: result.nbHits,
  };
};
